import React from "react"
import Head from "next/head"
import { MetaType, OG } from "."

interface Props {
  profileName: string
}

// -----------------------------
// Opengraph Docs — https://ogp.me/
// Facebook Opengraph for Video: https://developers.facebook.com/docs/sharing/webmasters#video

export const OGProfile = (props: Props) => {
  const { profileName } = props

  return (
    <Head>
      <meta
        data-testid={MetaType.ProfileName}
        key={MetaType.ProfileName}
        property={OG.ProfileName}
        content={profileName}
      />
    </Head>
  )
}
